import { sortBy } from 'lodash'
import { HTTP, caseOf, map } from '../lib'
import httpClient from '../api/httpClient'

export default {
  namespaced: true,

  state: {
    groups: HTTP.Request.Inactive(),
  },

  mutations: {
    setGroups: (state, groups) => {
      state.groups = groups
    },
  },

  getters: {
    groups: (state) => state.groups,
    list: (state) => caseOf(state.groups, { Done: (groups) => groups, _: () => [] }),
    storeGroups: (state) =>
      caseOf(state.groups, {
        Done: (groups) => map([{ name: 'All', id: '' }].concat(groups), ({ id, name }) => ({ value: id, label: name })),
        _: () => [],
      }),
  },

  actions: {
    fetch({ commit, state }) {
      return caseOf(state.groups, {
        Done: () => state.groups,
        _: () =>
          httpClient
            .get(`/storeGroups`)
            .then((response) => {
              commit('setGroups', HTTP.Request.Done(sortBy(response.data, (item) => (item.name || '').toLowerCase())))
            })
            .catch((err) => commit('setGroups', err)),
      })
    },
  },
}
